import { ChangeDetectionStrategy, Component } from '@angular/core';

import { BaseComponent } from '@ups/xplat/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-forms',
  templateUrl: 'forms.component.html',
  standalone: false,
})
export class FormsComponent extends BaseComponent {
  text = 'todo';
  constructor() {
    super();
  }
}
